import { RootStore, withInjectedRootStore } from 'providers';
import * as React from 'react';
import { Translation } from 'react-i18next';
import { SwitchPlanType } from '../../../../../enums';
import { ChangePlanModalContext } from '../../../ChangePlanModalContext';
import s from '../ChangePlanModal.scss';
import { PlanDetails } from './ChangePlanModalPlanDetails';
import { PlanRenwal } from './ChangePlanModalPlanRenewal';

interface ChangePlanModalPlanBoxProps {
  rootStore: RootStore;
  isCurrentPlan: boolean;
}

const ChangePlanModalPlanBoxComp: React.FC<ChangePlanModalPlanBoxProps> = ({
  rootStore,
  isCurrentPlan,
}) => {
  const { changePlanDetails } = React.useContext(ChangePlanModalContext);
  const { isDowngradePlanOfDeclineChargeService } = rootStore.appStore;
  const planDetails = isCurrentPlan
    ? changePlanDetails.currentPlanDetails
    : changePlanDetails.destinationProductDetails;
  const showUnpaidMsg =
    changePlanDetails.changePlanType === SwitchPlanType.GracePeriod;
  const showDiscountMsg = !!changePlanDetails.currentPlanDetails
    .discountedPrice;
  return (
    <Translation>
      {(t) => (
        <div className={s.modalBox}>
          <PlanDetails
            planDetails={planDetails}
            showUnpaidMsg={
              showUnpaidMsg || isDowngradePlanOfDeclineChargeService
            }
            showDiscountMsg={showDiscountMsg}
            isCurrentPlan={isCurrentPlan}
          />
          {changePlanDetails.changePlanType === SwitchPlanType.Extend && (
            <PlanRenwal
              planDetails={planDetails}
              amount={changePlanDetails.daysAdded}
              isCurrentPlan={isCurrentPlan}
            />
          )}
        </div>
      )}
    </Translation>
  );
};

export const ChangePlanModalPlanBox = withInjectedRootStore(
  ChangePlanModalPlanBoxComp,
);
